// ---------------------------------------------
// variables

export enum EUnitRole {
  None = '',
  Member = 'member',
  Resident = 'resident',
  Tenant = 'tenant',
  Relative = 'relative',
  PropertyManager = 'propertymanager',
  CustomerRep = 'customer-rep',
  Other = 'other',
}

export function getUnitRole(role: string) {
  if (role === EUnitRole.Member) return EUnitRole.Member
  if (role === EUnitRole.Resident) return EUnitRole.Resident
  if (role === EUnitRole.Tenant) return EUnitRole.Tenant
  if (role === EUnitRole.Relative) return EUnitRole.Relative
  if (role === EUnitRole.PropertyManager) return EUnitRole.PropertyManager
  if (role === EUnitRole.CustomerRep) return EUnitRole.CustomerRep
  if (role === EUnitRole.Other) return EUnitRole.Other

  return EUnitRole.None
}

export interface IUnitCreate {
  societyId: string;

  title: string;
  titleLegal?: string;

  isUnassigned?: boolean;
  residentsList?: {
    userId: string;
    role: EUnitRole;
    ownership?: number;
  }[];

  entranceId?: string;

  floor?: number;
  numberRooms?: number;
  size?: number;
  societyShare?: number;
  fee?: number;
  membershipId?: string;
  comment?: string;
}

export interface IUnitModel extends IUnitCreate {
  _id: string;
  createdAt: string;
  updatedAt: string;
}
